import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, from, map, Observable, switchMap, tap, throwError } from 'rxjs';
import { SnackbarApiService } from '../helpers/snackbar-api.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackbarApi: SnackbarApiService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.handleApiError(error)));
  }

  private handleApiError(error: HttpErrorResponse): Observable<any> {
    if (error.status === HttpStatusCode.NotFound) {
      const defaultMessage: string = 'Not found';

      if (typeof (error.error as any)?.message === 'string') {
        this.snackbarApi.failure((error.error as any).message);
        return throwError(() => error);
      }

      if (error.error instanceof Blob) {
        return from(error.error.text()).pipe(
          map((text: string) => {
            try {
              const parsed = JSON.parse(text);
              return typeof parsed?.message === 'string' ? parsed.message : defaultMessage;
            } catch {
              return defaultMessage;
            }
          }),
          tap((message: string) => this.snackbarApi.failure(message)),
          switchMap(() => throwError(() => error))
        );
      }

      this.snackbarApi.failure(defaultMessage);
      return throwError(() => error);
    }

    if (error.status === HttpStatusCode.BadRequest || error.status === HttpStatusCode.PayloadTooLarge) {
      if (typeof error.error.message === 'string') {
        this.snackbarApi.failure(error.error.message);
      }
    }

    return throwError(() => error);
  }
}
